// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-3cMokYdZ1vly_rX6Nbqhg_","light":"light--I73A60UBGVL3g8aJG73B","dark":"dark-1v-rwNTAxUYDfMw2ZmVS8G"};